/**
 * CCLP Buybox — gallery thumb switching and shade selection.
 * Used by sections/cclp-buybox.liquid.
 */
(function () {
  const thumbFullSrc = (src) => {
    if (!src) return '';
    return src
      .replace(/w=150/g, 'w=800')
      .replace(/h=150/g, 'h=800')
      .replace(/width=150/g, 'width=800');
  };

  class CclpBuybox extends HTMLElement {
    connectedCallback() {
      this.mainImg = this.querySelector('.cclp-buybox__main-img');
      this.thumbs = this.querySelectorAll('.cclp-buybox__thumb');
      this.dots = this.querySelectorAll('.cclp-buybox__shade-dot');
      this.nameDisplay = this.querySelector('[data-shade-name-display]');
      this.descDisplay = this.querySelector('[data-shade-desc-display]');

      if (!this.mainImg) return;

      this.thumbImages = [];
      this.thumbs.forEach((thumb) => {
        const img = thumb.querySelector('img');
        if (img) this.thumbImages.push(thumbFullSrc(img.src));
      });

      this._thumbHandlers = [];
      this.thumbs.forEach((thumb) => {
        const handler = () => {
          const idx = parseInt(thumb.getAttribute('data-thumb'), 10);
          this.thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
          if (this.thumbImages[idx]) {
            this.mainImg.src = this.thumbImages[idx];
            this.mainImg.alt = thumb.querySelector('img')?.alt || '';
          }
        };
        thumb.addEventListener('click', handler);
        this._thumbHandlers.push({ el: thumb, handler });
      });

      this._dotHandlers = [];
      this.dots.forEach((dot) => {
        const handler = () => {
          this.dots.forEach((d) => d.classList.remove('is-active'));
          dot.classList.add('is-active');
          this.thumbs.forEach((t) => t.classList.remove('is-active'));

          const shadeImg = dot.getAttribute('data-shade-img');
          if (shadeImg && this.mainImg) {
            this.mainImg.src = shadeImg;
            this.mainImg.alt = dot.getAttribute('title') || '';
          }

          if (this.nameDisplay) this.nameDisplay.textContent = dot.getAttribute('data-shade-name') || '';
          if (this.descDisplay) {
            this.descDisplay.innerHTML = `&nbsp; ${dot.getAttribute('data-shade-desc') || ''}`;
          }
        };
        dot.addEventListener('click', handler);
        this._dotHandlers.push({ el: dot, handler });
      });
    }

    disconnectedCallback() {
      (this._thumbHandlers || []).forEach(({ el, handler }) => el.removeEventListener('click', handler));
      (this._dotHandlers || []).forEach(({ el, handler }) => el.removeEventListener('click', handler));
    }
  }

  if (!customElements.get('cclp-buybox')) {
    customElements.define('cclp-buybox', CclpBuybox);
  }
})();
